import { render, staticRenderFns } from "./YsfpayTest.vue?vue&type=template&id=173add70&"
import script from "./YsfpayTest.vue?vue&type=script&lang=js&"
export * from "./YsfpayTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports